import { render, staticRenderFns } from "./AutoresponderTable.vue?vue&type=template&id=642f48b3&"
import script from "./AutoresponderTable.vue?vue&type=script&lang=js&"
export * from "./AutoresponderTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('642f48b3')) {
      api.createRecord('642f48b3', component.options)
    } else {
      api.reload('642f48b3', component.options)
    }
    module.hot.accept("./AutoresponderTable.vue?vue&type=template&id=642f48b3&", function () {
      api.rerender('642f48b3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Services/Hosting/Shared/Email/Autoresponders/AutoresponderTable.vue"
export default component.exports